<template>
  <div class="admin-User">
    <NavBarUserCenter></NavBarUserCenter>
    <router-view></router-view>
  </div>
</template>

<script>
import NavBarUserCenter from '../components/NavBarUsercenter';
export default {
  components: {
    NavBarUserCenter,
  },
}
</script>
